import { z } from 'zod';
export const Call_End_Call_1_ConfigValidator = z.object({
    message: z.string().optional()
});
//# sourceMappingURL=call-end-call-1.js.map